import Vue from "vue";
import store from "../store";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import LocalizedFormat from "dayjs/plugin/localizedFormat";
import customParseFormat from "dayjs/plugin/customParseFormat";
import duration from "dayjs/plugin/duration";
dayjs.extend(utc);
dayjs.extend(LocalizedFormat);
dayjs.extend(customParseFormat);
dayjs.extend(duration);
Vue.filter("formatDate", (value:any, filterFormat?:string) => {
  // @ts-ignore
  const { zone, format } = store.state.app.time;

  if (value) {
    return dayjs(value).format(filterFormat || format || "YYYY-MM-DD HH:mm:ss");
  }

  return "";
});
